import {
    ISubscriptionPackage, ISubscriptionsInfo, IPackagePricePeriod, ISubscriptionPeriod,
} from '@/interfaces';
import { SubscriptionState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setPeriods(state: SubscriptionState, payload: ISubscriptionPeriod[]) {
        state.periods = payload;
    },
    setPackages(state: SubscriptionState, payload: IPackagePricePeriod[]) {
        state.packages = payload;
    },
    setSubscriptionsInfo(state: SubscriptionState, payload: ISubscriptionsInfo) {
        state.subscriptionsInfo = payload;
    },
};

const {commit} = getStoreAccessors<SubscriptionState | any, State>('');

export const commitSetSubscriptionPeriods = commit(mutations.setPeriods);
export const commitSetSubscriptionPackages = commit(mutations.setPackages);
export const commitSetSubscriptionsInfo = commit(mutations.setSubscriptionsInfo);
